export const ACTION_CODE = "CONTRACT_ACTION";